import { SIGN_OUT } from 'Global/Stores/auth'

const FEEDBACK_SEND = 'API|FEEDBACK/SEND'
export const FEEDBACK_SEND_FULFILLED = `FULFILLED_${FEEDBACK_SEND}`
const FEEDBACK_SEND_PENDING = `PENDING_${FEEDBACK_SEND}`
const FEEDBACK_SEND_REJECTED = `REJECTED_${FEEDBACK_SEND}`

/**
 * POST request to API to send feedback.
 * @param {string} subject
 * @param {string} feedback
 * @param {Object} user
 */
export const sendFeedback = (subject, feedback, feedbackType, user) => ({
  meta: {
    data: { feedback, feedbackType, subject, user: { ...user, token: null } },
    method: 'post',
    successMessage: 'Feedback successfully sent. Thank you!.',
    url: '/api/v1/feedback',
  },
  type: FEEDBACK_SEND,
})

const initialState = {
  hasError: false,
  isPending: false,
}

const reducer = (state = initialState, action) => {
  const { type } = action

  switch (type) {
    case FEEDBACK_SEND_FULFILLED:
      return {
        ...state,
        hasError: false,
        isPending: false,
      }

    case FEEDBACK_SEND_PENDING:
      return {
        ...state,
        hasError: false,
        isPending: true,
      }

    case FEEDBACK_SEND_REJECTED:
      return {
        ...state,
        hasError: true,
        isPending: false,
      }

    case SIGN_OUT:
      return initialState

    default:
      return state
  }
}

export default reducer
